import { render } from "./WalletMessage.vue?vue&type=template&id=4878b42c&ts=true"
import script from "./WalletMessage.vue?vue&type=script&lang=ts"
export * from "./WalletMessage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__